import React, { FC } from 'react';
import { styled } from '@mui/system';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { colors } from 'src/themes/default';

const ThreeStateCheckboxComponent = styled('div')({
    display: 'inline-block',

    '&.disabled': {
        opacity: 0.3,
    },
});

export type ThreeStateValueType = 0 | 1 | -1;

export interface ThreeStateCheckboxPropsType {
    value?: ThreeStateValueType;
    onChange?: (value: ThreeStateValueType) => void;
    disabled?: boolean;
}

const ThreeStateCheckbox: FC<ThreeStateCheckboxPropsType> = (props) => {
    const getIcon = () => {
        switch (props.value) {
            case 1:
                return <CheckBoxIcon style={{ fill: colors.primary_O }} />;
            case -1:
                return <CheckCircleOutlineIcon style={{ fill: colors.primary_O }} />;
            case 0:
            default:
                return <CheckBoxOutlineBlankIcon style={{ fill: colors.text_T2 }} />;
        }
    };

    const onClick = (e: React.MouseEvent<HTMLElement>) => {
        if (props.disabled || !props.onChange) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        props.onChange(props.value === 1 ? 0 : 1);
    };

    return (
        <ThreeStateCheckboxComponent
            onClick={props.disabled ? undefined : onClick}
            className={`three-state-checkbox ${props.disabled ? 'disabled' : ''}`}
        >
            {getIcon()}
        </ThreeStateCheckboxComponent>
    );
};

export default ThreeStateCheckbox;
